import {RuleType} from '../../../../enums';
import {texts} from '../../../../texts';
import {texts as BPMTexts} from '../../../../modules/BPMRules/texts';

export const getEmptyStateTitle = (type: RuleType) => {
    if (type === RuleType.autofill) {
        return texts.empty_state_autofill_rule_title;
    } else if (type === RuleType.business) {
        return texts.empty_state_business_rule_title;
    } else if (type === RuleType.bpm) {
        return BPMTexts.empty_state_bpm_rule_title;
    }

    return '';
};

export const getEmptyStateText = (type: RuleType) => {
    if (type === RuleType.autofill) {
        return texts.empty_state_autofill_rule_text;
    } else if (type === RuleType.business) {
        return texts.empty_state_business_rule_text;
    } else if (type === RuleType.bpm) {
        return BPMTexts.empty_state_bpm_rule_text;
    }

    return '';
};
